import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import {
  Info as InfoIcon,
  Email as EmailIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { LeadFormActions } from '../../../Services/_actions';
import { useRecoilState } from 'recoil';
import { campaignLeadManagementAtom } from '../../../Services/_states';
import { isLightColor } from '../DynamicFormFields/helper.ts';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';

interface StatusCount {
  status: string;
  total_count: number;
  unique_count: number;
  count_percentage: number;
  unique_count_percentage: number;
  colorCode?: string;
}

const Reports = () => {
  const topSources = ['Whatsapp', 'Manual'];
  const [loading, setLoading] = useState < boolean > (true);
  const { showSnackBar } = useSnackBar();
  const leadActions = LeadFormActions();
  const [statusData, setStatusData] = useState < StatusCount[] > ([]);
  const [campaignLeadManagementData] = useRecoilState(campaignLeadManagementAtom);
  const campaignId = campaignLeadManagementData?.selectedCampaign?.proposal_id;
  const statusList =
    campaignLeadManagementData?.statusData?.[
    campaignLeadManagementData?.selectedForm?.leads_form_id
    ] ?? [];
  const [summaryResponse, setSummaryResponse] = useState({});

  const fetchSummary = async () => {
    if (!campaignId) return;
    setLoading(true);
    try {
      const res = await leadActions.getCampaignLeadSummary({ campaign_id: campaignId, status_id: status?.status_id ?? '', leads_form_id: campaignLeadManagementData?.selectedForm?.leads_form_id ?? "" });
      if (res?.status === 200) {
        setSummaryResponse(res?.data);
        if (statusList?.length > 0) {
          const formatted: StatusCount[] = Object.entries(res?.data?.status_summary || {})
            .filter(([key]) => key !== 'count_per' && key !== 'unique_count_per' && key !== 'status')
            .map(([status, value]: [string, any]) => {
              const matchedStatus = statusList.find(
                (s) => s.status_name.toLowerCase() === status.toLowerCase()
              );
              return {
                status,
                total_count: Number(value.total_count || 0),
                unique_count: Number(value.unique_count || 0),
                count_percentage: Number(value.count_percentage || 0),
                unique_count_percentage: Number(value.unique_count_percentage || 0),
                colorCode: matchedStatus?.colorCode || '#ccc', // fallback color
              };
            });
          setStatusData(formatted);
        }
      } else {
        showSnackBar("Error fetching summary data", "error")
      }
    } catch (err) {
      setStatusData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchSummary();
    // if (statusList.length > 0) {
    //   const isClosedStatus = statusList.find(s => s.isLeadClosed);
    //   fetchSummary(isClosedStatus);
    // }
  }, [campaignId]);

  const getConversionRate = () => {
    try {
      if (statusData.length === 0) return '0%';
      const closedStatus = statusList.find((s) => s?.isLeadClosed);
      if (!closedStatus) return '0%';
      const closeStatusData = statusData?.find((s) => s?.status?.toLowerCase() === closedStatus?.status_name?.toLowerCase());
      if (!closeStatusData) return '0%';
      const conversionRate = closeStatusData?.count_percentage;
      return `${conversionRate.toFixed(1)}%`;
    } catch (err) {
      return '0%';
    }
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
      {/* Lead Status Overview */}
      {/* <Box sx={{ flex: '1 1 300px', minWidth: 0 }}>
        <Card>
          <CardHeader title="Lead Status Overview" />
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {loading ? (
                <Typography>Loading...</Typography>
              ) : statusData.length === 0 ? (
                <Typography>No data available</Typography>
              ) : (
                statusData.map((item) => {
                  const lowerStatus = item.status.toLowerCase();
                  return (
                    <Box
                      key={item.status}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography sx={{ textTransform: 'capitalize' }}>{item.status}</Typography>
                      </Box>
                      <Chip
                        label={item.total_count}
                        sx={{
                          backgroundColor: item?.colorCode,
                          color:
                            !item.colorCode?.match(/^#([0-9A-Fa-f]{6})$/) ||
                              isLightColor(item?.colorCode)
                              ? '#000'
                              : '#fff',
                          fontWeight: 500,
                        }}
                      />
                    </Box>
                  );
                })
              )}
            </Box>
          </CardContent>
        </Card>
      </Box> */}

      {/* Performance Metrics */}
      {/* <Box sx={{ flex: '1 1 300px', minWidth: 0 }}>
        <Card>
          <CardHeader title="Performance Metrics" />
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Conversion Rate
                </Typography>
                <Typography variant="h4" color="primary">
                  {getConversionRate()}
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Avg Response Time
                </Typography>
                <Typography variant="h6">0 days</Typography>
              </Box>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  Monthly Growth
                </Typography>
                <Typography variant="h6" color="success.main">
                  0%
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box> */}

      {/* Top Lead Sources */}
      <Box sx={{ flex: '1 1 300px', minWidth: 0 }}>
        <Card>
          <CardHeader title="Top Record Sources" />
          <CardContent>
            <List>
              {/* {topSources?.map((source, index) => (
                <ListItem key={source}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: index === 0 ? 'primary.main' : 'grey.300' }}>
                      {summaryResponse?.whatsapp_total_leads ?? 0}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={source} />
                </ListItem>
              ))} */}
              <ListItem key={"Whatsapp"}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: true ? 'primary.main' : 'grey.300' }}>
                    {summaryResponse?.whatsapp_total_leads ?? 0}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Whatsapp"} />
              </ListItem>
              <ListItem key={"Manual"}>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: true ? 'primary.main' : 'grey.300' }}>
                    {(summaryResponse?.total_leads - summaryResponse?.whatsapp_total_leads) ?? 0}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Manual"} />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Reports;
